var map = {
	"./1.png": 9773,
	"./10.png": 1225,
	"./11.png": 48,
	"./12.png": 5083,
	"./2.png": 8566,
	"./3.png": 1231,
	"./4.png": 5360,
	"./5.png": 1609,
	"./6.png": 5522,
	"./7.png": 6651,
	"./8.png": 7164,
	"./9.png": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1565;